import { linearProgressClasses } from '@mui/material/LinearProgress';
import DEFAULT_PROGRESS_BAR_CLASS_NAME from '../../constants/linear-progress';

const defaultProgressBar = ({ theme }) => ({
  height: 4,
  borderRadius: 10,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.gray.A200,
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.secondary.A500,
  },
});

const MuiLinearProgress = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${DEFAULT_PROGRESS_BAR_CLASS_NAME}`]: defaultProgressBar({ theme }),
    }),
  },
};

export default MuiLinearProgress;
